import { RichTextEditor, RtePager, type RtePagerState } from '@orbind/ui'
import { useState } from 'react'
import { uploadWorkItemImage } from './api.ts'
import { ResizableField } from './ResizableField.tsx'

/**
 * Secao "Descricao" do detalhe do Item de Trabalho.
 *
 * Toda a edicao (toolbar completa, modo expandido paginado estilo Docs,
 * revisao, limpar, imagens) vive no componente compartilhado RichTextEditor
 * de @orbind/ui — mudou la, muda em todo lugar. Aqui fica apenas o cabecalho
 * da secao (recolher/expandir + lapis de editar).
 */
export function DescriptionEditor({
  value,
  onSave,
  collapsed,
  onToggleCollapsed,
  storageKey,
  info,
}: {
  value: string
  onSave: (html: string) => void
  collapsed: boolean
  onToggleCollapsed: () => void
  /** O "i" de instrucoes da Descricao (2026-09-01). */
  info?: import('react').ReactNode
  /** chave de persistência da altura da área de visualização (por item). */
  storageKey: string
}) {
  const [autoEdit, setAutoEdit] = useState(false)
  const [editing, setEditing] = useState(false)
  const [pager, setPager] = useState<RtePagerState | null>(null)

  return (
    <div>
      <div className="wi-sec__head" style={{ marginBottom: editing || !collapsed ? 6 : 0 }}>
        <button
          type="button"
          className="wi-sec__toggle"
          aria-label="Recolher/expandir descrição"
          aria-expanded={!collapsed}
          title="Recolher/expandir"
          onClick={onToggleCollapsed}
        >
          <i className={`fas fa-chevron-${collapsed ? 'right' : 'down'} wi-sec__chev`} aria-hidden />
        </button>
        <i className="fas fa-align-left wi-sec__ico" aria-hidden />
        <h3 className="wi-sec__title">Descrição</h3>
        {info}
        {!editing ? (
          <button
            type="button"
            className="wi-cl__iconbtn"
            aria-label="Editar descrição"
            title="Editar descrição"
            onClick={() => setAutoEdit(true)}
          >
            <i className="fas fa-pen" aria-hidden style={{ fontSize: 10 }} />
          </button>
        ) : null}
        <RtePager state={collapsed ? null : pager} />
      </div>

      {collapsed && !editing ? null : (
        <div style={{ marginLeft: 25 }}>
          {/* área de visualização redimensionável (padrão ~15 linhas); ao editar
              a caixa fica livre para o editor crescer. */}
          <ResizableField storageKey={`${storageKey}:desc`} maxHeight={340} active={!editing}>
            <div className="wi-rtebox">
              <RichTextEditor
                value={value}
                onSave={onSave}
                placeholder="Sem descrição — clique no lápis ou dê um duplo clique para editar."
                hideEditButton
                startEditing={autoEdit}
                onAutoStart={() => setAutoEdit(false)}
                onEditingChange={setEditing}
                onPagerChange={setPager}
                minHeight={140}
                onUploadImage={uploadWorkItemImage}
              />
            </div>
          </ResizableField>
        </div>
      )}
    </div>
  )
}
